import { render } from "./AdminBuilderCreate.vue?vue&type=template&id=a130954e&scoped=true&ts=true&lang=pug"
import script from "./AdminBuilderCreate.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminBuilderCreate.vue?vue&type=script&lang=ts&setup=true"

import "./AdminBuilderCreate.vue?vue&type=style&index=0&id=a130954e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a130954e"]])

export default __exports__